<template lang="pug">
v-dialog(
  v-model="show",
  max-width="600px",
  persistent
)
  v-card.notificacao.br-10
    v-card-title.md12.xs12.primary-title.title.pb-0 {{ notificacao ? notificacao.titulo + " " : "" }}
      .caption.ml-2.mt-2(v-if="notificacao") {{ $dayjs(notificacao.data_envio).format('DD/MM/YYYY [às] HH:mm') }}
    v-card-text.md8.xs8.subtitle(style="color: rgba(17, 19, 18, 0.70);", v-if="notificacao") {{ notificacao.mensagem }}
    v-card-actions.pt-0
      v-btn.btnVerMais.br-5(
        v-if="notificacao && notificacao.tipo_id == 2",
        color="primary",
        small,
        :href="notificacao.url",
        target="_blank"
      )
        | Ver mais
        i.fa.fa-arrow-up.iconSetaPraCima.ml-1
      v-spacer
      v-btn.btnFechar.br-5(
        text,
        flat
        @click="fechar"
      ) Fechar
</template>

<script>
export default {
  data() {
    return {
      show: false,
      notificacao: null
    }
  },
  methods: {
    abrir(notificacao) {
      this.notificacao = notificacao;
      this.$root.setLastAccessNotification(this.$dayjs().format());
      this.show = true;
    },
    fechar() {
      this.show = false;
      this.$root.setLastAccessNotification(this.$dayjs().format());
      this.notificacao = null;
    }
  }
}
</script>

<style scoped>
.br-5{
  border-radius: 5px !important;
}
.br-10{
  border-radius: 10px !important;
}

.title{
  font-family: "Poppins", "Roboto", "Helvetica" !important;
  font-weight: 500 !important;
}

.notificacao{
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(17, 19, 18, 0.08);
  background: white;
}

.btnVerMais{
  box-shadow: none !important;
  color: #fff !important;
  text-transform: capitalize !important;
}

.btnFechar{
  text-transform: capitalize !important;
}

.iconSetaPraCima{
  font-size:12px;
  -moz-transform: translateY(-1px);
  -o-transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px) rotate(45deg);
}
</style>
